import { useModal } from '@jutro/components';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { screenReaderAnnounce, validationUtil } from 'premier-capability-hooks';
import _ from 'lodash';
import { useCallback } from 'react';
import PECodegenWizardMessages from '../PECodegenWizard.messages';

const useWizardExit = ({ hasErrorOccurred, history, setIsLoading }) => {
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const { authHeader } = useAuthentication();
    const { showConfirm, showAlert } = useModal();
    const handleCancel = useCallback(
        ({ wizardSnapshot, param: nextPath = '', wizardData }) => {
            validationUtil.unSetIsValidationReqFlag(wizardData.value, ' ')
            const skipModal = ['knockoutpage', 'success', 'logout'];
            const lastPathName = nextPath.replace(/\/?.*\//g, '');
            const quoteSummaryRegex = /^\/quotes\/[0-9]+\/summary/;
            const accountSummaryRegex = /^\/accounts\/[0-9]+\/summary/;
            const periodStatus = _.get(
                wizardSnapshot,
                'baseData.periodStatus.value.code'
            );

            if (
                periodStatus === 'Bound' ||
                skipModal.includes(lastPathName) ||
                nextPath.match(quoteSummaryRegex) ||
                nextPath.match(accountSummaryRegex) ||
                hasErrorOccurred
            ) {
                // allow transition once the submission is bound
                // or returning to quote summary page
                return true;
            }

            return showConfirm({
                title: commonMessages.wantToCancel,
                message: commonMessages.infoWillBeSavedAsDraft,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.yes,
                cancelButtonText: commonMessages.no,
            }).then(results => {
                if (results === 'cancel' || results === 'close') {
                    screenReaderAnnounce('cancel window closed');
                                       
                    return _.noop();
                }
                const isStatusQuoted =
                    _.get(
                        wizardSnapshot,
                        'baseData.periodStatus.value.code'
                    ) === 'Quoted';

                let serverCall = LoadSaveService.updateDraftSubmission;

                if (isStatusQuoted) {
                    serverCall = LoadSaveService.updateQuotedSubmission;
                }

                const isValid =
                    wizardData.lobData.aspects.valid &&
                    wizardData.lobData.aspects.subtreeValid;
                const payload = isValid
                    ? _.get(wizardData, 'value')
                    : _.get(wizardSnapshot, 'value');
                const dataToSave = _.omit(_.get(wizardData, 'value'), 'bindData.paymentDetails');

                setIsLoading(true);
                const redirectPath = `/quotes/${dataToSave.quoteID}/summary`;
                serverCall(dataToSave, authHeader)
                    .then(() => {
                        history.push(nextPath || redirectPath);
                    })
                    .catch(() => {
                        showAlert({
                            title: PECodegenWizardMessages.anErrorOccurredTitle,
                            message: PECodegenWizardMessages.anErrorOccurred,
                            status: 'error',
                            icon: 'mi-error-outline',
                            confirmButtonText: commonMessages.ok,
                        }).catch(_.noop);
                        history.push(nextPath || redirectPath);
                    });
                return true;
            }, _.noop);
        },
        [
            hasErrorOccurred,
            showConfirm,
            LoadSaveService,
            setIsLoading,
            authHeader,
            history,
            showAlert,
        ]
    );
    return handleCancel;
};

export default useWizardExit;
